import React from "react";
import videojs from "video.js";
import "video.js/dist/video-js.css";
import "videojs-youtube";
import { getStaticFileUrl } from "../utils/config";

export const VideoJS = (props) => {
  const videoRef = React.useRef(null);
  const playerRef = React.useRef(null);
  const { options, onReady } = props;

  React.useEffect(() => {
    if (!playerRef.current) {
      // video.js 권장 방식에 따라 <video> 엘리먼트 동적 생성
      const videoElement = document.createElement("video");
      videoElement.classList.add("video-js", "vjs-big-play-centered");
      videoRef.current.appendChild(videoElement);

      // 유튜브 옵션 기본값
      const defaultYoutubeOptions = {
        theme: "dark",
        autoplay: 0,
        autohide: 0,
        cc_load_policy: 1,
        modestbranding: 1,
        fs: 0,
        showinfo: 0,
        rel: 0,
        iv_load_policy: 3,
        mute: 0,
        loop: 1,
      };

      // 영상 소스 URL을 정적 파일 URL로 변환
      const processedSources = options.sources?.map(source => ({
        ...source,
        src: source.src && !source.src.includes('youtube.com') && !source.src.includes('youtu.be') 
          ? getStaticFileUrl(source.src) 
          : source.src
      })) || [];

      // 기존 options에 fluid: true와 aspectRatio를 적용하여 반응형 처리
      const mergedOptions = {
        ...options,
        sources: processedSources,
        fluid: true,
        aspectRatio: options.aspectRatio || "16:9",
        youtube: {
          ...defaultYoutubeOptions,
          ...(options.youtube || {}),
        },
      };

      // video.js 초기화 (유튜브 소스의 경우 videojs-youtube 플러그인이 작동)
      const player = (playerRef.current = videojs(
        videoElement,
        mergedOptions,
        () => {
          videojs.log("player is ready");
          onReady && onReady(player);
        }
      ));
    } else {
      const player = playerRef.current;
      player.autoplay(options.autoplay);
      
      // 영상 소스 URL을 정적 파일 URL로 변환
      const processedSources = options.sources?.map(source => ({
        ...source,
        src: source.src && !source.src.includes('youtube.com') && !source.src.includes('youtu.be') 
          ? getStaticFileUrl(source.src) 
          : source.src
      })) || [];
      
      player.src(processedSources);
    }
  }, [options, onReady]);

  React.useEffect(() => {
    const player = playerRef.current;
    return () => {
      if (player && !player.isDisposed()) {
        player.dispose();
        playerRef.current = null;
      }
    };
  }, []);

  return (
    <div data-vjs-player>
      <div ref={videoRef} />
    </div>
  );
};

export default VideoJS;
